import { courseExamsApi } from "api/course-exams/courseExamsApi";
import { QUERIES_KEYS } from "queries";
import { useQuery } from "@tanstack/react-query";

export const useCourseExams = (courseId?: string | number) => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_EXAMS(courseId!),
    queryFn: () => courseExamsApi.fetchByCourseId(Number(courseId)),
    enabled: !!courseId,
  });
  return { isLoading, data, refetch };
};

export const useCourseExamsOptions = (courseId: string | number, isSystem?: boolean) => {
  const { isLoading, data } = useCourseExams(courseId);

  const options =
    (data?.data ?? [])
      .filter((x) => (isSystem === undefined ? true : x.isSystem === isSystem))
      .map((x) => ({
        value: x.id.toString(),
        label: x.name,
        exam: x,
      })) ?? [];

  return { isLoading, options };
};
